import { useState, useEffect } from "react";
import { db } from "../firebase"; // Importă din fișierul tău central
import { collection, onSnapshot, query, where } from "firebase/firestore";

export const useFirestoreData = (user) => {
  const [contracte, setContracte] = useState([]);
  const [datePartizi, setDatePartizi] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setLoading(false);
      return;
    }

    // --- CONFIGURARE QUERIES ---
    const qContracte =
      user.rol === "administrator"
        ? query(collection(db, "contracte"))
        : query(collection(db, "contracte"), where("ocol", "==", user.ocol));

    const qPartizi =
      user.rol === "administrator"
        ? query(collection(db, "partizi"))
        : query(collection(db, "partizi"), where("ocol", "==", user.ocol));

    // --- ASCULTARE CONTRACTE ---
    const unsubContracte = onSnapshot(
      qContracte,
      (snapshot) => {
        const date = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setContracte(date);
      },
      (error) => console.error("Eroare Firestore Contracte:", error),
    );

    // --- ASCULTARE PARTIZI ---
    const unsubPartizi = onSnapshot(
      qPartizi,
      (snapshot) => {
        const date = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setDatePartizi(date);
        setLoading(false);
      },
      (error) => console.error("Eroare Firestore Partizi:", error),
    );

    // --- CURĂȚENIE LA UNMOUNT ---
    return () => {
      unsubContracte();
      unsubPartizi();
    };
  }, [user]);

  return { contracte, datePartizi, loading };
};
